// extracted by mini-css-extract-plugin
export default {"path":"animatedLoader_path__haE6t","svg-text-anim":"animatedLoader_svg-text-anim__hz8pU"};